// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1304":"dd32af54eefce42c","4281":"e9d470320cf4e142","5517":"daf03be505a6579b","9939":"fc705152bdcb41a0"}[chunkId] + ".css";
};